import ProjectInfoStep from "../../components/Projects/Steps/ProjectInfoStep";

export default function ProjectInfoStepPage() {
  return <ProjectInfoStep />;
}
